import {Injectable} from '@angular/core';
import {Response, Headers, RequestOptions, ResponseContentType} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class PollPdfService {

  private urlPDF = `${ environment.apiRoot }/pdf-poll/`;

  constructor(private http: HttpAuth) { }

  public getPoll (poll_id: number, job_id: string): Observable<any> {
    return this.http.get(this.urlPDF + '?poll_id=' + poll_id + '&job_id=' + job_id, {responseType: ResponseContentType.Blob})
      .map(
          res => new Blob ([res.blob()], {type: res.headers.get('Content-Type')})
        )
      .catch(this.handleError);
  }



  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/poll-pdf.service.ts